import {defineStore} from "pinia";
import {OrderRecordListInfo} from "@/api/orders/receptionRecordType";


// 接待记录
export const useReceptionOrderStore = defineStore(
  'receptionOrder',
  () => {

    // 是否立即刷新列表
    const refreshList = ref(false)

    const orderDetail = ref<OrderRecordListInfo>()

    return {
      orderDetail,
      refreshList
    }
  })
